module.exports = __webpack_public_path__ + "static/media/balance_4_온도유지.0c66ed77.JPG";